/**
 * Favorites Service
 * Manages user's favorite contacts
 * Uses localStorage for persistence
 */

const STORAGE_KEY = 'peoplevue_favorites';

/**
 * Get all favorite employee IDs for a user
 */
export function getFavorites(userId) {
  try {
    const stored = localStorage.getItem(`${STORAGE_KEY}_${userId}`);
    return stored ? JSON.parse(stored) : [];
  } catch (e) {
    console.warn('Failed to load favorites:', e);
    return [];
  }
}

/**
 * Save favorites for a user
 */
function saveFavorites(userId, favorites) {
  try {
    localStorage.setItem(`${STORAGE_KEY}_${userId}`, JSON.stringify(favorites));
  } catch (e) {
    console.warn('Failed to save favorites:', e);
  }
}

/**
 * Add an employee to favorites
 */
export function addFavorite(userId, employeeId) {
  const favorites = getFavorites(userId);
  if (!favorites.includes(employeeId)) {
    favorites.push(employeeId);
    saveFavorites(userId, favorites);
  }
  return favorites;
}

/**
 * Remove an employee from favorites
 */
export function removeFavorite(userId, employeeId) {
  const favorites = getFavorites(userId).filter((id) => id !== employeeId);
  saveFavorites(userId, favorites);
  return favorites;
}

/**
 * Toggle favorite status
 */
export function toggleFavorite(userId, employeeId) {
  const favorites = getFavorites(userId);
  if (favorites.includes(employeeId)) {
    return removeFavorite(userId, employeeId);
  } else {
    return addFavorite(userId, employeeId);
  }
}

/**
 * Check if an employee is a favorite
 */
export function isFavorite(userId, employeeId) {
  return getFavorites(userId).includes(employeeId);
}

/**
 * Clear all favorites
 */
export function clearFavorites(userId) {
  saveFavorites(userId, []);
  return [];
}
